module.exports = __webpack_public_path__ + "static/media/streak-video.8ca6975a.mp4";